import { CompanyDetails } from "./components/CompanyDetails";
import { Industry } from "./Industry";
import { LicenseInformation } from "./components/LicenseInformation";
import { CompanyContactDetails } from "./components/CompanyContactDetails";
import { GA_EVENTS } from "../../../utils/ga";

export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;

export const MAX_REGISTRATION_NUMBER_LENGTH = 15;
export const MAX_LICENSE_NUMBER_LENGTH = 20;
export const MAX_YEARS_IN_BUSINESS_LENGTH = 3;
export const MAX_INDUSTRIES_LENGTH = 12;

export const companyInfoSteps = [
  {
    step: STEP_1,
    title: "Company Details",
    component: CompanyDetails,
    eventName: GA_EVENTS.SA_COMPANY_INFORMATION_DETAILS_CONTINUE
  },
  {
    step: STEP_2,
    title: "Company Contact Details",
    component: CompanyContactDetails,
    eventName: GA_EVENTS.SA_COMPANY_INFORMATION_CONTACT_CONTINUE
  },
  {
    step: STEP_3,
    title: "Industry",
    component: Industry,
    eventName: GA_EVENTS.SA_COMPANY_INFORMATION_INDUSTRY_CONTINUE
  },
  {
    step: STEP_4,
    title: "License Information",
    component: LicenseInformation,
    eventName: GA_EVENTS.SA_COMPANY_INFORMATION_LICENSE_CONTINUE
  }
];
export const TYPE = [
  {
    key: "bankName",
    code: "bankName",
    displayText: "Bank Name",
    value: "Bank Name",
    subGroup: null
  },
  {
    key: "exchangeHouse",
    code: "exchangeHouse",
    displayText: "Exchange House",
    value: "Exchange House",
    subGroup: null
  },
  {
    key: "other",
    code: "other",
    displayText: "Other(Please Specify)",
    value: "Other",
    subGroup: null
  }
];

export const PERCENTAGE_ANNUAL_INTERVALS = [
  { value: 0, label: "0" },
  { value: 10, label: "10" },
  { value: 20, label: "20" },
  { value: 30, label: "30" },
  { value: 40, label: "40" },
  { value: 50, label: "50" },
  { value: 60, label: "60" },
  { value: 70, label: "70" },
  { value: 80, label: "80" },
  { value: 90, label: "90" },
  { value: 100, label: "100%" }
];
export const TENANCY_CONTRACT_OPTIONS = [
  {
    key: "yes",
    code: "yes",
    displayText: "Yes",
    value: "yes",
    subGroup: null
  },
  {
    key: "no",
    code: "no",
    displayText: "No",
    value: "no",
    subGroup: null
  },
  {
    key: "notApplicable",
    code: "notApplicable",
    displayText: "Not Applicable",
    value: "notApplicable",
    subGroup: null
  }
];
export const STOCK_SIGHTED_OPTIONS = [
  {
    key: "yes",
    code: "yes",
    displayText: "Yes",
    value: "yes",
    subGroup: null
  },
  {
    key: "no",
    code: "no",
    displayText: "No",
    value: "no",
    subGroup: null
  }
];
export const SPLIT_OPTIONS = [{ value: 0, label: "50 %" }, { value: 100, label: "50 %" }];

export const PERCENTAGE_ANNUAL_SALES = "What is % of annual sales within this industry?";
export const SPLIT_BTW_INTERNATIONAL_LOCAL_SALES =
  "What is the split between the company's international and local sales?";
export const SPLIT_BTW_WHOLESALE_RETAIL_TRADE =
  "What is company split between wholesale and retail trade";
export const COMPANY_INFO_SALES_ASSIST_PAGE_ID = "companyInfoSalesAssist";
